import type { Observable } from 'rxjs';
import { of } from 'rxjs';

import { Injectable } from '@angular/core';

import type { IValidationErrors } from '../models';

import { ErrorsTextsProviderBaseService } from './errors-texts-provider-base.service';
import errorsMap from './errors-map';

type ErrorsMapKey = keyof typeof errorsMap;

@Injectable({ providedIn: 'root' })
export class ErrorsTextsProviderService extends ErrorsTextsProviderBaseService {

	renderFirstErrorTextAndObserveChanges(
		validationErrors: IValidationErrors,
		controlName?: number | string | null,
	): Observable<string> {
		return of(this._renderValidationErrorsAsTexts(validationErrors, controlName)[0]);
	}

	protected _fetchErrorTextWithMasks(validatorName: string, controlName?: number | string | null): string | null {
		const controlSpecificError: string | null = controlName
			? errorsMap[<ErrorsMapKey>`${ validatorName }.${ controlName }`]
			: null;

		const generalError = <string | undefined>errorsMap[<ErrorsMapKey>validatorName];

		return controlSpecificError ?? generalError ?? null;

	}
}
